// src/constants/shopStatus.js

export const SHOP_STATUSES = {
  LISTED: "listed",
  OFFER_PENDING: "offer_pending",
  OFFER_ACCEPTED: "offer_accepted",
  PAYMENT_PENDING: "payment_pending",
  PAID_HELD: "paid_held",
  AWAITING_BUYER_CONFIRMATION: "awaiting_buyer_confirmation",
  COMPLETED: "completed",
  DISPUTED: "disputed",
};

// DB-facing offer status constants
export const OFFER_STATUS_PENDING = "pending";
export const OFFER_STATUS_ACCEPTED = "accepted";
export const OFFER_STATUS_DECLINED = "declined";
export const OFFER_STATUS_PAID_HELD = "paid_held";
export const OFFER_STATUS_HANDED_OVER = "handed_over";
export const OFFER_STATUS_COMPLETED = "completed";
export const OFFER_STATUS_DISPUTED = "disputed";

export const SHOP_STATUS_LABELS = {
  [SHOP_STATUSES.LISTED]: "Open",
  [SHOP_STATUSES.OFFER_PENDING]: "Offer pending",
  [SHOP_STATUSES.OFFER_ACCEPTED]: "Offer accepted",
  [SHOP_STATUSES.PAYMENT_PENDING]: "Payment pending",
  [SHOP_STATUSES.PAID_HELD]: "Payment received (held by Mudo)",
  [SHOP_STATUSES.AWAITING_BUYER_CONFIRMATION]: "Awaiting buyer confirmation",
  [SHOP_STATUSES.COMPLETED]: "Completed",
  [SHOP_STATUSES.DISPUTED]: "Disputed",
};

// Map DB offer.status -> UI shop status
export const OFFER_STATUS_TO_SHOP_STATUS = {
  [OFFER_STATUS_PENDING]: SHOP_STATUSES.OFFER_PENDING,
  [OFFER_STATUS_ACCEPTED]: SHOP_STATUSES.OFFER_ACCEPTED,
  [OFFER_STATUS_PAID_HELD]: SHOP_STATUSES.PAID_HELD,
  [OFFER_STATUS_HANDED_OVER]: SHOP_STATUSES.AWAITING_BUYER_CONFIRMATION,
  [OFFER_STATUS_COMPLETED]: SHOP_STATUSES.COMPLETED,
  [OFFER_STATUS_DISPUTED]: SHOP_STATUSES.DISPUTED,
};
